class ScrollToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.ticking = false;

    this.button?.addEventListener('click', this.scrollToTop);
    window.addEventListener('scroll', this.requestUpdate, { passive: true });
    window.addEventListener('resize', this.requestUpdate);
    this.update();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.scrollToTop);
    window.removeEventListener('scroll', this.requestUpdate);
    window.removeEventListener('resize', this.requestUpdate);
  }

  requestUpdate = () => {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  };

  update() {
    const scrollElement = document.scrollingElement || document.documentElement;
    const maxScroll = scrollElement.scrollHeight - window.innerHeight;
    const scrollTop = window.lenis?.scroll ?? scrollElement.scrollTop;
    const progress = maxScroll > 0 ? Math.min((scrollTop / maxScroll) * 100, 100) : 0;
    const threshold = Number(this.dataset.threshold || 220);

    this.style.setProperty('--scroll-to-top-progress', progress + '%');
    this.classList.toggle('is-visible', scrollTop > threshold);
  }

  scrollToTop = () => {
    if (window.lenis?.scrollTo) {
      window.lenis.scrollTo(0);
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  };
}

if (!customElements.get('scroll-to-top')) {
  customElements.define('scroll-to-top', ScrollToTop);
}
